import { ComponentType, Suspense, useCallback, useEffect, useState } from "react";
import RemoteErrorBoundary from "../error-boundary";
import RemoteFailurePanel from "../remote-failure-panel";

const REMOTE = "art_datalake";
const EXPOSED_MODULE = "art_datalake/gateway";

export default function ArtDatalakeLoader() {
  const [Gateway, setGateway] = useState<ComponentType | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => { setGateway(null); setError(null); setAttempt(x => x + 1); }, []);
  useEffect(() => { let active=true; import("art_datalake/gateway").then((m) => { if (!m.default) throw new Error(`${EXPOSED_MODULE} did not export a default component`); if(active)setGateway(()=>m.default); }).catch(e=>{if(active)setError(e)}); return()=>{active=false}; }, [attempt]);
  if(error)return <RemoteFailurePanel remote={REMOTE} exposedModule={EXPOSED_MODULE} phase="module" error={error} onRetry={retry}/>;
  if(!Gateway)return <div>Loading Datalake…</div>;
  return <Suspense fallback={<div>Loading Datalake…</div>}><RemoteErrorBoundary key={attempt} remote={REMOTE} exposedModule={EXPOSED_MODULE} onRetry={retry}><Gateway/></RemoteErrorBoundary></Suspense>;
}
